import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { UserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { logError } from "@faire/web--source/common/logging";
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { isWindowUndefined } from "@faire/web--source/common/server-side-rendering/isWindowUndefined";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import notifyWhenBackInStock from "@faire/web-api--source/api/product/itemToken/notify/retailerToken/back-in-stock/post";
import deleteBackInStockNotification from "@faire/web-api--source/api/product/productOptionToken/notify/retailerToken/back-in-stock/delete";
import getEventSubscriptions from "@faire/web-api--source/api/retailer/retailerToken/event-subscriptions/get";
import { EventSubscriptionType } from "@faire/web-api--source/indigofair/data/EventSubscriptionType";
import { IEventSubscriptionsCompletionStatusEnum } from "@faire/web-api--source/indigofair/data/IEventSubscriptionsCompletionStatusEnum";
import { UserRole } from "@faire/web-api--source/indigofair/data/UserRole";
import { action, computed, observable } from "mobx";
/**
 * @deprecated prefer to use `useEventSubscriptionStore` or `withStores` instead
 */ export var EventSubscriptionStore = /*#__PURE__*/ function() {
    "use strict";
    function EventSubscriptionStore() {
        var _this = this;
        _class_call_check(this, EventSubscriptionStore);
        var _this1 = this;
        this.eventSubscriptions = [];
        this.userStore = UserStore.get();
        this.retailerStore = RetailerStore.get();
        this.isValidRetailer = function() {
            // Only check for the existence of retailer token is not sufficient because
            // a brand user can also have a retailer token that looks like r_{brandToken}
            return _this.retailerStore.retailer && _this.retailerStore.retailer.token && _this.userStore.user && _this.userStore.user.roles && _this.userStore.user.roles.indexOf(UserRole.RETAILER) !== -1;
        };
        this.fetchEventSubscriptions = /*#__PURE__*/ _async_to_generator(function() {
            var retailerToken, params, response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this1.isValidRetailer()) return [
                            3,
                            2
                        ];
                        // Retrieve subscriptions this retailer previously made for back ordered
                        // products and product options.
                        retailerToken = _this1.retailerStore.retailer.token;
                        params = {
                            type: EventSubscriptionType.BACK_IN_STOCK,
                            completed: IEventSubscriptionsCompletionStatusEnum.EventSubscriptionsCompletionStatus.ONLY_INCOMPLETED
                        };
                        return [
                            4,
                            getEventSubscriptions(retailerToken, params)
                        ];
                    case 1:
                        response = _state.sent();
                        _this1.eventSubscriptions = response.event_subscriptions || [];
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        this.subscribeBackInStock = function(identifier) {
            return notifyWhenBackInStock(identifier, _this.retailerStore.retailer.token).then(function() {
                return _this.fetchEventSubscriptions();
            }).catch(function(e) {
                logError(e);
            });
        };
        this.unsubscribeBackInStock = function(identifier) {
            return deleteBackInStockNotification(identifier, _this.retailerStore.retailer.token);
        };
        makeObservable(this);
        if (isWindowUndefined()) {
            return;
        }
        this.fetchEventSubscriptions();
    }
    _create_class(EventSubscriptionStore, [
        {
            key: "BackInStockIdentifiers",
            get: function get() {
                // Return a list of identifiers (which can be product token or product
                // option token) that's back ordered and been subscribed.
                return this.eventSubscriptions.reduce(function(accumulator, event) {
                    if (event.event_identifier) {
                        accumulator[event.event_identifier] = true;
                    }
                    return accumulator;
                }, {});
            }
        }
    ]);
    return EventSubscriptionStore;
}();
EventSubscriptionStore.get = singletonGetter(EventSubscriptionStore);
__decorate([
    observable
], EventSubscriptionStore.prototype, "eventSubscriptions", void 0);
__decorate([
    action
], EventSubscriptionStore.prototype, "fetchEventSubscriptions", void 0);
__decorate([
    action
], EventSubscriptionStore.prototype, "subscribeBackInStock", void 0);
__decorate([
    action
], EventSubscriptionStore.prototype, "unsubscribeBackInStock", void 0);
__decorate([
    computed
], EventSubscriptionStore.prototype, "BackInStockIdentifiers", null);
export var useEventSubscriptionStore = createStoreHook(EventSubscriptionStore);
